import {Injectable} from '@angular/core';
import {TreeNode} from "primeng/api";
import {TreeTable} from "primeng/treetable";
import {UserService} from "@app/core";
import {Table} from "primeng/table";
import {CommonDataService, CommonTransformationService, LedgerAccount} from "@app/shared";
import {TrialBalance} from "@app/finance/general-ledger/general-ledger";

@Injectable()
export class CommonTreeService {

  constructor(private user: UserService, private transformationService: CommonTransformationService) {
  }

  resetGlobalFilter(dt: Table) {
    let searchInput = <HTMLInputElement>document.getElementById('searchInput');
    searchInput.value = '';
    dt.reset();
  }

  setChildProperty(children, property, value) {
    children.forEach(acc => {
      acc[property] = value;
      if (acc['children'].length > 0) {
        this.setChildProperty(acc['children'], property, value);
      }
    });

  }

  sortNodesAndChildren(nodes, property) {
    if (nodes) {
      nodes.sort((a, b) => (a[property] > b[property]) ? 1 : -1);
      for (let node of nodes) {
        if (node['children']?.length >= 0) {
          this.sortNodesAndChildren(node['children'], property);
        }
      }
    }
  }

  sortTreeNodesAndChildren(nodes: TreeNode[], property) {
    if (nodes) {
      nodes.sort((a, b) => (a.data[property] > b.data[property]) ? 1 : -1);
      for (let node of nodes) {
        if (node['children']?.length >= 0) {
          this.sortNodesAndChildren(node['children'], property);
        }
      }
    }
  }

  /**
   * expand all the nodes in the treeTable
   */
  expandTreeTable(treeTable: TreeTable): void {
    for (let treeNode of treeTable.value) {
      this.expandTreeNode(treeNode);
    }
  }

  /**
   * recursively expand node and its children
   */
  expandTreeNode(treeNode: TreeNode): void {
    if (treeNode.children) {
      if (!treeNode.expanded) {
        treeNode.expanded = true;
      }
      for (let child of treeNode.children) {
        this.expandTreeNode(child);
      }
    }
  }

  /**
   * collapse all the nodes in the treeTable
   */
  collapseTreeTable(treeTable: TreeTable) {
    for (let treeNode of treeTable.value) {
      this.collapseTreeeNode(treeNode);
    }
  }

  /**
   * recursively collapse node and its children
   */
  collapseTreeeNode(treeNode: TreeNode) {
    if (treeNode.children) {
      if (treeNode.expanded) {
        treeNode.expanded = false;
      }
      for (let child of treeNode.children) {
        this.collapseTreeeNode(child);
      }
    }
  }

  disableParentNodeSelection(treeNodes: TreeNode[]) {
    treeNodes.forEach(treeNode => {
      if (treeNode.children.length > 0) {
        treeNode.selectable = false;
      }
    });
  }

  convertListToTree<T>(objArray: Array<T>, idIndex: string, parentIdIndex: string, labelIndex: string): Array<T> {
    let hashTable = {};
    objArray.sort((a, b) => a[labelIndex] < b[labelIndex] ? -1 : a[labelIndex] > b[labelIndex] ? 1 : 0);

    objArray.forEach(obj => hashTable[obj[idIndex]] = {...obj, children: new Array<T>()});
    let objTree = new Array<T>();
    objArray.forEach(obj => {
      if (obj[parentIdIndex] && hashTable[obj[parentIdIndex]]) {
        hashTable[obj[parentIdIndex]].children.push(<T>hashTable[obj[idIndex]]);
      } else {
        objTree.push(<T>hashTable[obj[idIndex]]);
      }
    });
    return objTree;
  }

  convertListToTreeNode<T>(objArray: Array<T>, idIndex: string, parentIdIndex: string, labelIndex: string): TreeNode<T>[] {
    const tree = this.convertListToTree(objArray, idIndex, parentIdIndex, labelIndex);
    return <TreeNode<T>[]>this.transformationService.convertToTree(labelIndex, tree);
  }

  convertTreeToTreeNode<T>(treeArray: Array<T>, labelIndex: string): TreeNode<T>[] {
    return <TreeNode<T>[]>this.transformationService.convertToTree(labelIndex, treeArray);
  }
}
